export default {
  Accept: 'تایید',
  Admin: 'ادمین',
  areYouSureOfYourRequest: 'ایا از درخواست خود مطمئن هستید؟',
  AvailableStartTime: 'تاریخ شروع اعتبار',
  AvailableExpireTime: 'تاریخ انقضا اعتبار',
  AddPolygon: 'افزودن ناحیه',
  Block: 'بلاک',
  unauthorized: 'اجازه ی انجام این درخواست را ندارید',
  badRequest: 'درخواست اشتباه',
  operationFailed: 'درخواست شما انجام نشد',
  Address: 'آدرس',
  validationFailed: 'خطای اعتبارسنجی',
  invalidToken: 'لطفا دوباره وارد شوید',
  internalServerError: 'خطای داخلی سرور',
  Update: 'بروز رسانی',
  Save: 'ذخیره',
  edit: 'ویرایش',
  EditPolygon: 'ویرایش ناحیه',
  Enabled: 'فعال',
  Disabled: 'غیرفعال',
  Delete: 'حذف',
  Submit: 'تایید',
  Create: 'افزودن',
  company: 'باربری',
  City: 'شهر',
  Color: 'رنگ',
  Car: 'ماشین',
  Country: 'کشور',
  Province: 'استان',
  customer: 'مشتری',
  ConvertToValidDataPolygon: 'تبدیل به دیتای معتبر نقشه',
  View: 'نمایش',
  OopsYouAreLost: 'مسیر را اشتباه رفته اید!',
  ThePageYouAreLookingForWasNotFound: 'صفحه مورد نظر شما وجود ندارد.',
  OopsWeHaveAProblem: 'مشکلی پیش آمده!',
  ThePageYouAreLookingForIsTemporaryUnavailable:
    'صفحه مورد نظر شما موفقتا در دسترس نیست.',
  YouAreOffline: 'به نظر می آید ارتباط شما با سرویس دهنده برقرار نیست.',
  Search: 'جستجو',
  Add: 'افزودن',
  Remove: 'حذف',
  Report: 'گزارش',
  RangeTitle: 'محدوده بار',
  NoRecords: 'رکوردی برای نمایش وجود ندارد',
  LoadingRecords: 'در حال لود رکوردها',
  NoMatchingRecords: 'هیچ رکوردی منطبق با جستجوی شما یافت نشد',
  Return: 'بازگشت',
  Confirmation: 'تایید',
  AreYouSureToAcceptThisRecord:
    'آیا مطمئن هستید که می خواهید این رکورد را تایید کنید؟',
  AreYouSureToRemoveThisRecord:
    'آیا مطمئن هستید که می خواهید این رکورد را حذف کنید؟',
  AreYouSureToRemoveThisItem:
    'آیا مطمئن هستید که می خواهید این آیتم را حذف کنید؟',
  yes: 'بله',
  no: 'خیر',
  Cancel: 'لغو',
  SortOrder: 'ترتیب',
  Title: 'عنوان',
  Parent: 'مادر',
  Description: 'توضیحات',
  Image: 'تصویر',
  Images: 'تصاویر',
  HeaderImage: 'تصویر سربرگ',
  Featured: 'برگزیده',
  NetworkError: 'خطای اتصال به شبکه',
  PleaseSelect: 'لطفا انتخاب کنید',
  MoreInfo: 'اطلاعات بیشتر',
  Name: 'نام',
  Url: 'آدرس پیوند',
  Category: 'دسته',
  Count: 'تعداد',
  Close: 'بستن',
  Filter: 'اعمال فیلتر',
  FromDate: 'تاریخ از',
  Send: 'ارسال',
  Select: 'انتخاب',
  status: 'وضعیت',
  creationTime: 'تاریخ ثبت',
  Text: 'متن',
  Icon: 'آیکون',
  Choose: 'انتخاب کنید...',
  Label: 'برچسب',
  Legal: 'کاربر حقوقی',
  Price: 'قیمت',
  Slug: 'Slug',
  All: 'همه',
  Active: 'فعال',
  Email: 'ایمیل',
  Mobile: 'شماره همراه',
  DuplicateName: 'نام تکراری',
  DuplicateSlug: 'Slug تکراری',
  Driver: 'راننده',
  Drivers: 'کلیه رانندگان',
  Details: 'جزییات',
  ReadedIn: 'خوانده شده در',
  RelatedCompany: 'باربری',
  ResetFilter: 'حذف فیلترها',
  YouHave: 'شما',
  Approved: 'تایید شده',
  Unapproved: 'تایید نشده',
  AutoLocation: 'مکان یابی خودکار',
  HtmlText: 'متن HTML',
  Hour: 'ساعت',
  PlainText: 'متن Plain',
  publish: 'انتشار',
  PublishDate: 'تاریخ انتشار',
  BasicFeatures: 'ویژگی های پایه',
  SeoFeatures: 'ویژگی های سئو',
  PageTitle: 'عنوان صفحه',
  ShownInBrowserTab: 'در Tab مرورگر نمایش داده میشود',
  PageDescription: 'توضیحات صفحه',
  PageDescriptionForSearchEngines: 'توضیحات صفحه برای موتورهای جستجو',
  Percent: 'درصد',
  Hits: 'بازدید',
  Until: 'تا',
  User: 'کاربر',
  Network: 'شبکه',
  AppLogo: 'لوگو @:branding.AppName',
  SubTypes: 'انواع زیرین',
  Published: 'منتشر شده',
  Confirm: 'تایید',
  Person: 'نفر',
  Points: 'نقاط',
  Row: 'ردیف',
  Render: 'رندر',
  Register: 'ثبت',
  RegistrationTimeMax: 'تاریخ ثبت تا',
  RegistrationTimeMin: 'تاریخ ثبت از',
  Day: 'روز',
  Month: 'ماه',
  Year: 'سال',
  Number: 'عدد',
  Free: 'رایگان',
  Warning: 'هشدار',
  MinDate: 'از تاریخ',
  MaxDate: ' تا تاریخ',
  Date: 'تاریخ',
  EndTimeMin: 'ساعت پایان از',
  EndTimeMax: 'ساعت پایان تا',
  ExpireDate: 'تاریخ اعتبار',
  ExpireDateMin: 'تاریخ اعتبار از',
  ExpireDateMax: 'تاریخ اعتبار تا',
  Availability: 'دسترسی',
  Amount: 'مقدار',
  MinAmount: 'حداقل مقدار',
  MaxAmount: 'حداکثر مقدار',
  MoreInformation: 'اطلاعات بیشتر',
  EndDate: 'تاریخ پایان',
  ExpireTimeMin: 'تاریخ انقضا از',
  ExpireTimeMax: 'تاریخ انقضا تا',
  loadTime: 'تاریخ بارگیری',
  load: 'بارگیری',
  _time: 'زمان {action}',
  collection: 'جمع آوری',
  OrderTimeMin: 'تاریخ سفارش از',
  OrderTimeMax: 'تاریخ سفارش تا',
  NotOfficialHoliday: 'تعطیلی غیر رسمی',
  OfficialHoliday: 'تعطیلی رسمی',
  OfficialType: 'نوع تعطیلی',
  Organization: 'سازمان',
  StartDate: 'تاریخ شروع',
  StartDateMin: 'تاریخ شروع از',
  StartDateMax: 'تاریخ شروع تا',
  StartTime: 'از ساعت',
  StartTimeMin: 'ساعت آغاز از',
  StartTimeMax: 'ساعت آغاز تا',
  MaxSpeed: 'بیشترین سرعت',
  AvgSpeed: 'سرعت میانگین',
  SelectAll: 'همه',
  Selectoneormoreitems: 'انتخاب یک یا چند مورد',
  State: 'وضعیت',
  SearchUser: 'جستجوی کاربر',
  EndTime: 'تا ساعت',
  ToDate: 'تاریخ تا ',
  TrafficType: 'نوع طرح',
  loadType: 'نوع بار',
  Time: 'زمان',
  Table: 'جدول',
  Tables: 'جداول',
  Trajectory: 'تاریخچه مسیر',
  CurrentTrajectory: 'مسیر جاری',
  Live: 'موقعیت لحظه‌ای',
  UserTester: 'کاربر تستی',
  Users: 'کاربران',
  Total: 'مجموع',
  Tariff: 'تعرفه',
  Clone: 'سفارش مجدد',
  Editor: 'ویراستار',
  registrationTime: 'تاریخ ثبت نام',
  Step: 'مرحله',
  Steps: 'مراحل',
  PricingMethod: 'نحوه قیمت دهی',
  Speed: 'سرعت',
  Support: 'پشتیبانی',
  WeekDay: 'روز هفته',
  Permissions: 'دسترسی ها',
  MainFields: 'مشخصات اصلی',
  RolesList: 'لیست نقش ها',
  SubmitShipment: 'ثبت سفارش',
  Feedbacks: 'بازخورد ها',
  dateAndTime: 'تاریخ و ساعت',
  NoChangeHaveBeenMade: 'هیچ تغییری ایجاد نشده است!',
  No_: 'شماره',
  ShipmentId: 'شناسه سفارش',
  NothingFound: 'موردی یافت نشد',
  ClientType: 'نوع کلاینت',
  from: 'از',
  to: 'تا',
  percent: 'درصد',
  availableDate: 'تاریخ اعتبار',
  startTime: 'ساعت شروع',
  endTime: 'ساعت پایان',
  origin: 'مبدا',
  destination: 'مقصد',
  loadLocation: 'مبدا',
  dischargeLocation: 'مقصد',
  _choosing: 'انتخاب',
  _coordinates: 'مختصات',
  _onMap: 'روی نقشه',
  chooseCoordinatesOnMap: 'مختصات را روی نقشه مشخص کنید',
  completeInformation: 'اطلاعات تکمیلی',
  _editedSuccessfully: 'با موفقیت ویرایش شد',
  furniture: 'اسباب‌کشی',
  cargo: 'بار سنگین',
  urban: 'شهری',
  intercity: 'بین شهری',
  select: 'انتخاب',
  selected: 'انتخاب شده',
  selectAll: 'انتخاب همه',
  ton: 'تن',
  kilogram: 'کیلوگرم',
  meter: 'متر',
  pending: 'در انتظار تایید',
  accepted: 'تایید شده',
  completed: 'تکمیل شده',
  canceled: 'لغو شده',
  id: 'شناسه',
  excelDownload: 'دانلود اکسل',
  _itemsFound: '{count} مورد یافت شد',
  tariffStatus: 'وضعیت تعرفه',
  hasExpiredTariff: 'دارای تعرفه منقضی شده',
  noTariff: 'بدون تعرفه',
  loading: 'درحال بارگیری ...',
  thereAreNoRecordsToShow: 'رکوردی برای نمایش وجود ندارد',
  thereAreNoRecordsMatchingYourRequest:
    'هیچ رکوردی منطبق با جستجوی شما یافت نشد',
  item: 'مورد',
  show: 'نمایش',
  links: 'پیوند ها',
  details: 'جزییات',
  dischargeDate: 'تاریخ تخلیه',
  dischargeTime: 'زمان تخلیه',
  weight: 'وزن',
  length: 'طول',
  width: 'عرض',
  height: 'ارتفاع',
  showInWebsite: 'مشاهده در وبسایت',
  operationType: 'نوع عملیات',
  startDate: 'تاریخ شروع',
  expireDate: 'تاریخ انقضا',
  birthDate: 'تاریخ تولد',
  totalAmount: 'جمع کل',
  loads: 'سفارش‌ها',
  nothingAdded: 'موردی اضافه نشده',
  areYouSureYouWantToDelete_: "آیا از حذف ' {itemToDelete} ' اطمینان دارید؟",
  areYouSureYouWantTo_this_: 'آیا از {action} این {type} اطمینان دارید؟',
  enabling: 'فعال کردن',
  disabling: 'غیرفعال کردن',
  approve: 'تایید',
  reject: 'رد',
  areYouSureYouWantTo__: "آیا از {action} ' {title} ' اطمینان دارید؟",
  _hasBeenDoneSuccessfully: '{title} با موفقیت انجام شد',
  _notFound: '{title} یافت نشد',
  _hasBeenCreatedSuccessfully: '{title} با موفقیت ایجاد شد',
  _hasBeenEditedSuccessfully: '{title} با موفقیت ویرایش شد',
  _hasBeenDeletedSuccessfully: '{title} با موفقیت حذف شد',
  _hasBeenEnabledSuccessfully: '{title} با موفقیت فعال شد',
  _hasBeenDisabledSuccessfully: '{title} با موفقیت غیرفعال شد',
  event: 'رویداد',
  _haveBeenGeneratedSuccessfully: '{title} با موفقیت تولید شدند',
  millimeter: 'میلیمتر',
  amount: 'مبلغ',
  descriptionRequired: 'توضیحات الزامی است؟',
  updateType: 'نوع ویرایش',
  payments: 'پرداختی ها',
  isPaid: 'پرداخت شده؟',
  publicView: 'نمایش عمومی',
  showAggregation: 'نمایش مجموع',
  now: 'اکنون',
  noTimeSelected: 'زمان انتخاب نشده است',
  reset: 'حذف',
  courier: 'باربری',
  courierOrDriver: 'باربری / راننده',
  couriers: 'باربری ها',
  website: 'وب سایت',
  _mobile: 'موبایل',
  android: 'اندروید',
  ios: 'iOS',
  score: 'امتیاز',
  _pageTitleEdit: 'ویرایش {title}',
  _pageTitleCreate: 'افزودن {title}',
  _excelName: 'لیست {title}',
  list: 'لیست {title}',
  collectionTime: 'تاریخ جمع‌آوری',
  notSupported: 'پشتیبانی نمی شود',
  supported: 'پشتیبانی می شود',
  registerOrder: 'ثبت سفارش',
  nextStep: 'مرحله بعد',
  previousStep: 'مرحله قبل',
  ip: 'ای پی',
  _pageTitleLog: 'لاگ {title}',
  fieldName: 'نام فیلد',
  newValue: 'مقدار جدید',
  oldValue: 'مقدار قبلی',
  mainDetails: 'اطلاعات کلی',
  _pageTitleLogDetail: 'جزئیات لاگ {title}',
  pressEnterToSelect: 'برای انتخاب Enter را فشار دهید',
  pressEnterToRemove: 'برای حذف Enter را فشار دهید',
  description: 'توضیحات',
  image: 'تصویر',
  enable: 'فعال',
  title: 'عنوان',
  slug: 'Slug',
  row: 'ردیف',
  sortOrder: 'ترتیب نمایش',
  info: 'اطلاعات',
  email: 'ایمیل',
  name: 'نام',
  mobile: 'موبایل',
  lastName: 'نام خانوادگی',
  permissions: 'دسترسی ها',
  delete: 'حذف',
  moreInfo: 'اطلاعات بیشتر',
  mainFields: 'مشخصات اصلی',
  user: 'کاربر',
  plate: 'پلاک',
  floor: 'طبقه',
  unit: 'واحد',
  rolesList: 'لیست نقش ها',
  feedbacks: 'بازخورد ها',
  availableStartTime: 'تاریخ شروع اعتبار',
  availableExpireTime: 'تاریخ انقضا اعتبار',
  cancel: 'لغو',
  send: 'ارسال',
  shipmentId: 'شناسه سفارش',
  relatedCompany: 'باربری',
  rial: 'ریال',
  excel: 'اکسل',
  bulkCreate: 'افزودن به صورت انبوه',
  relinquishment: 'انصراف',
  confirm: 'تایید',
  _count_hasBeenCreatedSuccessfully: '{count} {title} با موفقیت ایجاد شد',
  publishTime: 'زمان انتشار',
  metaDescription: 'توضیحات صفحه',
  metaTitle: 'عنوان صفحه',
  parentCategory: 'دسته والد',
  homePage: 'صفحه اصلی',
  phone: 'تلفن',
  male: 'آقا',
  female: 'خانم',
  address: 'آدرس',
  file: 'فایل',
  month: 'ماه',
  attachment: 'پیوست',
  icon: 'آیکون',
  downloadSimpleExcel: 'دانلود نمونه اکسل',
  default: 'پیشفرض',
  areYouSureOfRegisteringDestinationWeighBridge:
    'آیا از ثبت باسکول مقصد اطمینان دارید؟',
  areYouSureOfRegisteringOriginWeighBridge:
    'آیا از ثبت باسکول مبدا اطمینان دارید؟',
  minute: 'دقیقه',
  until: 'تا',
  doesNotHave: 'ندارد',
  and: 'و',
  favicon: 'favicon',
  logo: 'لوگو',
  totalAmount: 'مبلغ کل',
  payableAmount: 'مبلغ قابل پرداخت',
  commission: 'کمیسیون',
  courierDiscount: 'تخفیف باربری',
  marketplaceDiscount: 'تخفیف باربانت',
  priceDetails: 'جزئیات قیمت',
  cost: 'هزینه',
  plateTemplate: 'ایران {iran} - {right} {character} {left}',
  count: 'تعداد',
  discount: 'تخفیف',
  type: 'نوع',
  content: 'محتویات',
  print: 'چاپ',
  text: 'متن',
  restTime: 'زمان استراحت (تعداد)',
  select: 'انتخاب',
  attachments: 'پیوست ها',
  operation: 'عملیات',
  period: 'بازه',
  new: 'جدید',
  noItem: 'گزینه ای موجود نمیباشد',
  future: 'آینده',
  clock: 'ساعت',
  year: 'سال',
  day: 'روز',
  hour: 'ساعت',
  seconds: 'ثانیه',
  timeDistance: {
    past: 'قبل',
    future: 'بعد'
  },
  register: 'ثبت',
  removeSelection: 'حذف انتخاب',
  clone: 'clone',
  resultCount: 'تعداد نتایج',
  selectedItem: 'مورد انتخاب شده',
  selectedItems: 'موارد انتخاب شده',
  creator: 'سازنده',
  licenseCategory: 'دسته مجوز',
  measurementId: 'شناسه اندازه گیری',
  currencyId: 'شناسه پول',
  sizeId: 'شناسه اندازه',
  colorId: 'شناسه رنگ',
  holidayId: 'شناسه تعطیلات',
  theAmountShouldNotBeMoreThan_: 'مبلغ نباید بیشتر از {amount}ریال باشد',
  prevPage: 'صفحه قبل',
  accessDenied: 'عدم دسترسی',
  accessToThisPageIsNotPossible: 'دسترسی به این صفحه امکان پذیر نیست',
  financialExcelDownload: 'دانلود اکسل گزارش مالی',
  edited: 'ویرایش شده',
  submit: 'تایید',
  userTester: 'کاربر تستی',
  male: 'مرد',
  female: 'زن',
  undefined: 'نامشخص',
  add: 'افزودن',
  users: 'کاربران',
  invalidFormat: 'فرمت ورودی نامعتبر میباشد',
  support: 'پشتیبانی',
  actions: 'عملیات',
  car: 'خودرو',
  receipt: 'رسید',
  formal: 'رسمی',
  informal: 'غیر رسمی',
  kmPerHour: 'کیلومتر بر ساعت',
  doesntMatter: 'فرقی ندارد',
  searchAddress: 'جستجو آدرس',
  searchDriver: 'جست‌وجو راننده',
  revertChanges: 'بازگرداندن تغییرات',
  package: 'بسته بندی',
  digitToAlphabet: {
    1: 'اول',
    2: 'دوم',
    3: 'سوم',
    4: 'چهارم',
    5: 'پنجم'
  },
  nothingFound: 'موردی یافت نشد!',
  search: 'جستوجو',
  zipCode: 'کدپستی',
  'destination-1': 'مقصد اول',
  'destination-2': 'مقصد دوم',
  'destination-3': 'مقصد سوم',
  'destination-4': 'مقصد چهارم',
  'destination-5': 'مقصد پنجم',
  'destination-6': 'مقصد ششم',
  'destination-7': 'مقصد هفتم',
  'destination-8': 'مقصد هشتم',
  'destination-9': 'مقصد نهم',
  'destination-10': 'مقصد دهم',
  company_: 'شرکت',
  category: 'دسته بندی',
  connected: 'متصل',
  connect: 'اتصال',
  disconnect: 'قطع اتصال',
  selectAtLeastOneItemIsRequired: 'انتخاب حداقل یک مورد الزامی است!',
  name: 'نام',
  family: 'نام خانوادگی',
  vehicle: 'وسیله نقلیه',
  issueTime: 'تاریخ صدور',
  expireTime: 'تاریخ انقضا',
  plateType: 'نوع پلاک',
  fuelType: 'نوع سوخت',
  vip: 'vip',
  descriptionEnabled: 'نمایش توضیحات',
  gatheringLocation: 'محل جمع‌آوری',
  dischargeLocation: 'محل تخلیه',
  operationType: 'نوع عملیات',
  displayName: 'نام و نام خانوادگی',
  reason: 'دلیل',
  userCategory: 'گروه کاربران',
  branch: 'شعبه',
  registered: 'ثبت شده',
  youCanOnlySelectUpTo_Items: 'میتوانید حداکثر {count} مورد را انتخاب کنید',
  to: ' تا ',
  consMaxValue: 'حداکثر مقدار برای نقاط ضعف',
  prosMinValue: 'حداقل مقدار برای نقاط قوت',
  acceptableOffer: 'قبول پیشنهاد',
  paymentType: 'روش پرداخت',
  paymentMobile: 'موبایل پرداخت کننده',
  paymentName: 'نام پرداخت کننده ',
  loadingTime: 'زمان بارگیری',
  acceptable: 'قابل قبول',
  automatic: 'اتوماتیک',
  customers: 'مشتریان',
  admins: 'مدیران',
  shipper: 'صاحب کالا',
  ChangePrice: 'ویرایش مبلغ',
  paymentEnquiry: 'استعلام پرداخت',
  negotiatorMobile: 'موبایل رابط',
  step: 'مرحله',
  skip: 'تحویل ناموفق',
  paymentMethod: 'شیوه پرداخت',
  contactNumber: 'شماره تماس'
}
